'use strict';

const STAMPSY_AUTH_SIZE = { w: 475, h: 620 };
const SERVICE_AUTH_SIZE = { w: 550, h: 500 };

function openUrl(url, options={}) {
  const { popup = true, size = SERVICE_AUTH_SIZE } = options;
  if (popup) {
    window.open(url, '',
      'resizeable=true,height=' + size.h +
      ',width=' + size.w + ',left=' + ((window.innerWidth - size.w) / 2) +
      ',top=' + ((window.innerHeight - size.h) / 2));
  } else {
    window.location.href = url;
  }
}

const PopupManager = {
  openConnect: function (serviceType, options={}) {
    const params = [];
    let url = '/connect/' + serviceType.toLowerCase() + '/popup?';

    if (options.scope) {
      params.push('scope=' + options.scope);
    }

    url += params.join('&');

    openUrl(url, options);
  },

  openLogin: function (serviceType, options={}) {
    const url = serviceType ? `/login/${serviceType.toLowerCase()}/popup` : '/login/popup';

    if (!options.size) {
      options.size = serviceType ? SERVICE_AUTH_SIZE : STAMPSY_AUTH_SIZE;
    }

    openUrl(url, options);
  },

  openSignup: function (serviceType, options={}) {
    const url = serviceType ? `/signup/${serviceType.toLowerCase()}/popup` : '/signup/popup';

    if (!options.size) {
      options.size = serviceType ? SERVICE_AUTH_SIZE : STAMPSY_AUTH_SIZE;
    }

    openUrl(url, options);
  }
};

export default PopupManager;


/** WEBPACK FOOTER **
 ** ./utils/PopupManager.js
 **/